const canUse = (function() {
  try {
    sessionStorage.setItem('saucey', 'test');
    sessionStorage.removeItem('saucey');
    return true;
  } catch (e) {
    return false;
  }
})();

const store = {
  get(key) {
    return canUse ? sessionStorage.getItem(key) : null;
  },

  set(key, value) {
    return canUse ? sessionStorage.setItem(key, value) : null;
  },

  remove(key) {
    return canUse ? sessionStorage.removeItem(key) : null;
  }
};

export function startNewSession() {
  if (isNewSession()) store.set('sessionStartedAt', Date.now());
}

export function isNewSession() {
  return !store.get('sessionStartedAt');
}

export default store;



// WEBPACK FOOTER //
// ./shared/utils/sessionStore.js